import { formatHundredths } from '../decimal.ts';

/**
 * The sentence a circle's prompts and a round solid's volume share (ADR 0140
 * §4). "pi" is spelt out because the Greek letter is not in WinAnsi (ADR 0070).
 */
const piSentence = () => `Use 3.14 for pi.`;

/** English circle prompts (ADR 0106 §3). */
export const circlePrompts = {
    piSentence,
    circumference: () => `Find the circumference. ${piSentence()}`,
    area: () => `Find the area. ${piSentence()}`,
    diameterFromCircumference: (circumference: string) =>
        `The circumference is ${circumference}. ${piSentence()} What is the diameter?`,
    /** A number of hundredths as the sheet writes it: a point. */
    decimal: (hundredths: number) => formatHundredths(hundredths, '.'),
};
